import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="VibeTunes"
              description="Our application boasts a range of innovative features, including advanced search capabilities, highly customizable playlists, and a sophisticated music player. We've prioritized user experience through a sleek, responsive design and seamless performance, ensuring that you can enjoy your music effortlessly."
              ghLink="https://github.com/imarani494/Rights-Reactors_022/tree/Main"
              demoLink="https://vibetunesweb.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Health is Welth"
              description="The Health and Wellness Project aims to create a platform that provides a holistic and personalized approach to health management. With the increasing importance of maintaining a healthy lifestyle, this project addresses the challenges individuals face in managing their health effectively. The platform integrates various aspects of wellness, including physical activity tracking, nutrition management, mental wellness, and personalized health advice, into a cohesive and user-friendly application."
              ghLink="https://github.com/sagarrathod7568/Health-and-Wellness-App"
              demoLink="https://pixel-pole-vault-040.vercel.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Melodify"
              description="Our project is a Spotify Clone, designed to emulate the core functionalities of Spotify, a popular music streaming service. The primary aim of this project is to provide users with a seamless and engaging platform to stream music, create and manage playlists, discover new songs and artists, and enjoy a personalized listening experience."
              ghLink="https://github.com/ritikamish/Uber-Unicorns_073?tab=readme-ov-file"
              demoLink="https://uber-unicorns073-melodify.netlify.app/"              
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
